module.exports = "/images/audio.png?66297312f95ddb44d0b17d817cad5b78";